"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importStar(require("react"));
const react_apollo_network_status_1 = require("react-apollo-network-status");
const reactstrap_1 = require("reactstrap");
const react_2 = require("@osmosys/react");
const react_use_1 = require("react-use");
exports.OsmosysLoadingIndicator = ({ online, }) => {
    const { numPendingQueries, mutationError, queryError, numPendingMutations, } = react_apollo_network_status_1.useApolloNetworkStatus();
    const [stickiedError, triggerStickyError] = react_2.useTimedToggle(6 * 1000);
    const hasError = !!(queryError || mutationError);
    react_1.useEffect(() => {
        if (hasError) {
            triggerStickyError();
        }
    }, [hasError]);
    const userIsIdle = react_use_1.useIdle(5 * 1000);
    const transactionCount = (numPendingQueries || 0) + (numPendingMutations || 0);
    return (react_1.default.createElement("div", { className: "top-loader-outer" },
        react_1.default.createElement(reactstrap_1.Progress, { animated: transactionCount > 0, striped: transactionCount > 0, value: 100 / (transactionCount || 1), bar: true, className: classnames_1.default('top-loader', userIsIdle
                ? 'top-loader-idle'
                : !online
                    ? 'top-loader-error'
                    : stickiedError
                        ? 'top-loader-warning'
                        : '') })));
};
//# sourceMappingURL=OsmosysLoadingIndicator.js.map